import { axiosInstance } from "../../utils/axios";

const EMBACK_URL = import.meta.env.VITE_EMBACK_URL;

export interface TenantUser {
  _id: string;
  email: string;
  first_name?: string;
  last_name?: string;
}

export async function getTenantUsers(userId: string): Promise<TenantUser[]> {
  const { data } = await axiosInstance.get<TenantUser[]>(
    `${EMBACK_URL}/data/users`,
    { params: { userId } }
  );
  return data;
}
